import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { TopbarComponent } from './topbar/topbar.component';
import { AlertaComponent } from './alerta/alerta.component';
import { RouterModule } from '@angular/router';
import { VentanaComponent } from './ventana/ventana.component';
import { PaginaMantenimientoComponent } from './pagina-mantenimiento/pagina-mantenimiento.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { NotificationComponent } from './notification/notification.component';

@NgModule({
  declarations: [
    FooterComponent, 
    TopbarComponent, 
    AlertaComponent,
    VentanaComponent ,
    PaginaMantenimientoComponent,
    NotificationComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    DialogsModule
  ],
  exports:[
    TopbarComponent,
    FooterComponent,
    AlertaComponent,
    PaginaMantenimientoComponent,
    VentanaComponent
  ]
})
export class SharedModule { }
